import { createApp } from 'vue'
import App from './App.vue'
import VueClipboard from 'vue3-clipboard'

//TAILWIND
import './index.css'

//GOOGLE TAG MANAGER
import VueGtag from "vue-gtag";

var isProd = process.env.NODE_ENV === 'production';

const app = createApp(App)
app.use(VueClipboard, {
    appendToBody: false
})

app.use(VueGtag, {
    enabled: isProd,
    config: { id: isProd ? process.env.VUE_APP_GATAG : "G-0000000000" }
  })

app.mount('#app')
